import Cookies from "js-cookie";

const USER_EMAIL_COOKIE_NAME = "BISNEmailAddress";

export const getUserEmail = () => {
  const encodedEmail = Cookies.get(USER_EMAIL_COOKIE_NAME);

  if (typeof window === "undefined" || !encodedEmail) {
    return "";
  }

  return window.atob(encodedEmail);
};
